import timer from "../../library/util/timer";
import { v4 as uuidv4 } from 'uuid';
import checkmateApi from "../axios/checkmateApi";


export const getCandidateSummary = async (entityType: string, entityId: string) => {
    const response = checkmateApi({
        method: 'GET',
        url: `${entityType.toLowerCase()}/details/${entityId}`
    });
    return response;
}

export const expandCandidateSearch = async (entityType: string, entityId: string) => {
    const response = checkmateApi({
        method: 'GET',
        url: `${entityType.toLowerCase()}/search/${entityId}`
    });
    return response;
}

export const createCandidateNotes = async (payload: any) => {
    const { ...data } = payload;
    const response = checkmateApi({
        method: 'POST',
        url: `note`,
        data
    });
    return response;
}

export const updateCandidateNotes = async (payload: any) => {
    const { id, ownerId, ...data } = payload;
    const response = checkmateApi({
        method: 'PUT',
        url: `note/${id}`,
        data
    });
    return response;
}
